import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import classNames from 'classnames';

import { withLocales } from '@spotahome/bff/client';
import { localesShape } from '@spotahome/bff/shapes';
import Metrics from '@spotahome/soyuz-metrics';

import AdsQueryApiService from '../../../LEGACY/javascripts/cornucopia/ads/ads-query-api-service';

import HomeCard from '../Homecard';

import EmptyList from './EmptyList';
import NoResultsMessage from './NoResultsMessage';

import './HomeCardList.scss';

function scrollToCard(cardClicked) {
  if (cardClicked) {
    const scrollOffset =
      $('.search-filters').height() -
      $('.search-results').height() +
      $('.search-context').height();

    $('.search-scroll').animate(
      {
        scrollTop: cardClicked.offsetTop + scrollOffset
      },
      1000
    );
  }
}

function hasNewMarkers(oldMarkers, newMarkers) {
  return (
    JSON.stringify(oldMarkers.map(e => e.id)) !==
    JSON.stringify(newMarkers.map(e => e.id))
  );
}

function indexCardsById(cards) {
  return cards.filter(card => card).reduce(
    (acc, card) => ({
      ...acc,
      ...{
        [card.id]: card
      }
    }),
    {}
  );
}

async function getCardsFromIds(cardIds, locale) {
  let newCards = {};
  if (cardIds.length) {
    try {
      const res = await AdsQueryApiService.getHomecardsFromIds(cardIds, locale);

      if (res.data) {
        newCards = indexCardsById(res.data.homecards);
      }
    } catch (err) {
      console.log(err);
    }
  }

  return newCards;
}

function getCardIds(cards = []) {
  return cards
    .reduce((acc, marker) => [...acc, ...marker.rentableUnits], [])
    .map(card => ({
      id: card.id,
      coord: card.coord
    }));
}

function isHomecardSelected(currentCardId, clickedCards) {
  const { rentableUnitIds = [] } = clickedCards || {};
  return rentableUnitIds.includes(currentCardId);
}

const hasFilters = (filters = {}) =>
  !!Object.keys(filters).reduce(
    (acc, filterKey) => acc || filters[filterKey].length,
    false
  );

class HomeCardList extends PureComponent {
  static propTypes = {
    results: PropTypes.number.isRequired,
    totalResults: PropTypes.number.isRequired,
    markerList: PropTypes.array.isRequired,
    filters: PropTypes.object,
    onCardMouseEnter: PropTypes.func,
    onCardMouseLeave: PropTypes.func,
    clearExtendedFilters: PropTypes.func,
    calculateMarkersWithoutBounds: PropTypes.func,
    adMarkerClicked: PropTypes.object,
    pointOfInterest: PropTypes.object,
    locales: PropTypes.shape(localesShape).isRequired,
    currentPage: PropTypes.number.isRequired,
    hasMap: PropTypes.bool.isRequired
  };

  state = {
    indexedCards: this.props.initialHomecards,
    cardList: getCardIds(this.props.markerList),
    cardsLoading: false
  };

  componentWillReceiveProps = async nextProps => {
    if (this.props.adMarkerClicked !== nextProps.adMarkerClicked) {
      if (nextProps.adMarkerClicked.id) {
        const firstRentableUnit = nextProps.adMarkerClicked.id;
        scrollToCard(this[firstRentableUnit]);
      }
    }

    if (hasNewMarkers(this.props.markerList, nextProps.markerList)) {
      document.querySelector('.search-filters').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      this.setState({
        cardsLoading: true
      });

      const cardList = getCardIds(nextProps.markerList);
      const cardListIds = cardList.map(card => card.id);

      if (nextProps.markerList.length === 0 && !this.state.cardsLoading) {
        Metrics.ga.sendEvent('search-page', 'no-results-found');
      }

      $('#spinner-list-loader').show();
      let indexedCards;
      try {
        indexedCards = await getCardsFromIds(
          cardListIds,
          this.props.locales.current
        );

        this.setState({
          cardList,
          indexedCards,
          cardsLoading: false
        });
      } catch (err) {
        console.log(err);
      }

      $('#spinner-list-loader').fadeOut();
    }
  };

  trackCardPosition = (position, cardData) => () => {
    const { photoUrls, monthlyPrice } = cardData;
    const track = [
      position,
      hasFilters(this.props.filters),
      this.props.hasMap,
      this.props.currentPage,
      this.state.cardList.length,
      cardData.id,
      photoUrls.homecard,
      monthlyPrice.minimumPrice,
      cardData.checked,
      cardData.type,
      cardData.isInstantBooking
    ];

    Metrics.ga.sendEventWithClientId(
      'dwh-click-homecard-relevance',
      track.join(';')
    );
  };

  render() {
    let content;
    const { indexedCards, cardsLoading, cardList } = this.state;
    const { adMarkerClicked } = this.props;

    if (cardsLoading) {
      content = <EmptyList />;
    } else if (this.props.markerList && Object.keys(indexedCards).length) {
      content = cardList.map((card, position) => {
        const cardData = indexedCards[card.id];
        if (cardData) {
          return (
            <div
              className="l-list__item"
              key={`homecard-${card.id}`}
              ref={node => {
                this[card.id] = node;
              }}
            >
              <HomeCard
                coord={card.coord}
                currency={this.props.currency}
                data={cardData}
                id={cardData.id}
                isFavorite={cardData.isFavorite}
                moveIn={this.props.filters['move-in']}
                moveOut={this.props.filters['move-out']}
                onCardMouseEnter={this.props.onCardMouseEnter}
                onCardMouseLeave={this.props.onCardMouseLeave}
                onClick={this.trackCardPosition(position, cardData)}
                pointOfInterest={this.props.pointOfInterest}
                reviews={cardData.reviews}
                selected={isHomecardSelected(card.id, adMarkerClicked)}
              />
            </div>
          );
        }
        return null;
      });
    } else {
      content = (
        <NoResultsMessage
          totalResults={this.props.totalResults}
          clearExtendedFilters={this.props.clearExtendedFilters}
          results={this.props.results}
          centerResultsInMap={this.props.calculateMarkersWithoutBounds}
        />
      );
    }

    const classes = classNames({
      'l-list': true,
      'l-list--marker-selected': this.props.adMarkerClicked !== null
    });

    return (
      <div data-cy="property-list" className={classes}>
        {content}
      </div>
    );
  }
}

export default withLocales()(HomeCardList);
